// src/pages/CategoryPage.jsx
import { useEffect, useState, useCallback } from 'react'
import { useParams, Link } from 'react-router-dom'
import { fetchCategoryWithChildren } from '../lib/categories'

const PLACEHOLDER =
  'https://via.placeholder.com/640x480?text=GoShop'

export default function CategoryPage() {
  const { catId } = useParams()
  const [cat, setCat] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await fetchCategoryWithChildren(catId)
      setCat(data)
    } catch (e) {
      setError(e?.message || 'Erreur de chargement')
    } finally {
      setLoading(false)
    }
  }, [catId])

  useEffect(() => {
    load()
  }, [load])

  if (loading) {
    return <div className="alert alert-info">Chargement…</div>
  }
  if (error) {
    return <div className="alert alert-danger">Erreur : {error}</div>
  }
  if (!cat) {
    return <div className="alert alert-warning">Catégorie introuvable.</div>
  }

  const children = Array.isArray(cat.children)
    ? cat.children.filter((sc) => sc.id && sc.label)
    : []

  const catImage = cat.imageUrl || PLACEHOLDER

  return (
    <div>
      {/* Header catégorie avec image */}
      <div className="card-modern mb-4 p-3 p-md-4">
        <div className="d-flex flex-column flex-md-row align-items-center gap-3">
          <div className="flex-fill">
            <div className="small text-uppercase text-muted mb-1">
              Catégorie
            </div>
            <h2 className="m-0">{cat.label}</h2>
            <p className="text-muted mt-2 mb-0" style={{ fontSize: '.9rem' }}>
              Découvrez les sous-catégories et affinez votre recherche
              de produits dans {cat.label}.
            </p>
            {/* <div className="mt-3">
              <Link to="/catalog" className="btn btn-soft btn-sm">
                Tous les produits
              </Link>
            </div> */}
          </div>
          <div
            style={{
              width: 140,
              height: 140,
              borderRadius: 16,
              overflow: 'hidden',
              background: '#0b1226',
              flexShrink: 0,
            }}
          >
            <img
              src={catImage}
              alt={cat.label}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={(e) => {
                e.currentTarget.src = PLACEHOLDER
              }}
            />
          </div>
        </div>
      </div>

      {/* Sous-catégories */}
      {children.length === 0 ? (
        <div className="alert alert-secondary">Aucune sous-catégorie.</div>
      ) : (
        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
          {children.map((ch) => {
            const img =
              ch.imageUrl ||
              `https://via.placeholder.com/640x480?text=${encodeURIComponent(
                ch.label
              )}`

            return (
              <div className="col" key={ch.id}>
                <div className="card-modern h-100 d-flex flex-column">
                  <Link
                    to={`/catalog?sub=${encodeURIComponent(
                      ch.id
                    )}&sublabel=${encodeURIComponent(
                      ch.label
                    )}&cat=${encodeURIComponent(
                      cat.id
                    )}&label=${encodeURIComponent(cat.label)}`}
                    
                  >
                    <div className="product-thumb">
                      <div className="frame">
                        <img
                          src={img}
                          alt={ch.label}
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.src = PLACEHOLDER
                          }}
                        />
                      </div>
                    </div>
                  </Link>
                  <div className="product-body d-flex flex-column">
                    <h6 className="product-title mb-2 line-clamp-2">
                      {ch.label}
                    </h6>
                    <div className="mt-auto">
                      {/* Lien vers le catalogue filtré par sous-catégorie */}
                      <Link
                        to={`/catalog?sub=${encodeURIComponent(
                          ch.id
                        )}&sublabel=${encodeURIComponent(
                          ch.label
                        )}&cat=${encodeURIComponent(
                          cat.id
                        )}&label=${encodeURIComponent(cat.label)}`}
                        className="btn btn-primary btn-sm"
                      >
                        Voir les produits
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
